<pdq-dropdown
  selectBy="checked"
  [options]="inputConfig?.options | stringDropdownOptions: initialSelectedValues"
  [defaultOption]="
    isMultiSelect
      ? (inputConfig?.options | stringDropdownOptions: initialSelectedValues)
      : (initialSelectedValues[0] | stringDropdownOption)
  "
  (onMultiSelectChange)="onMultiSelectChange($event)"
  (onChange)="onSingleSelectChange($event)"
  [placeholder]="variable?.placeholder"
  [invalid]="valuesForm?.invalid"
  [multiSelect]="isMultiSelect"
  [showSelectUnselectOptions]="isMultiSelect"
  [enableSearch]="isMultiSelect"
  [concatinatedLabelOptionsThreshold]="DROP_DOWN_LABEL_THRESHOLD"
  mode="underline"></pdq-dropdown>
